export default __webpack_public_path__ + "static/media/left-ear.de2bc39d.svg";